import React from 'react';
import routes from './app-routers';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import ScrollToTop from './components/UI/ScrollToTop/ScrollToTop';
import './App.css';

function App() {
  const resizeObserver = new ResizeObserver(entries => {
    let message = { height: document.body.scrollHeight };
    window.top.postMessage(message, "*");
  });
  resizeObserver.observe(document.body)

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        {routes.map(({ path, component }) => (
          <Route
            exact
            key={path}
            path={path}
            component={component}
          />
        ))}    
      </Switch>
    </BrowserRouter>
  );
}

export default App;
